import { classes as htmlClasses } from 'html-classes';
import { observer } from 'mobx-react-lite';

import { company } from '~/company/Company';
import { createCategoryUrl } from '~/components/CategoryBlocks/utils';

import { Card } from '../shared/Card';
import { GridView, tileClassNames } from '../shared/GridView';
import { BlockCommonProps } from '../shared/interfaces';
import { ViewAllButton } from '../shared/ViewAllButton';

import styles from './CategoriesGrid2M.module.scss';

const CategoriesGrid2M = ({ category, classes }: BlockCommonProps) => {
  const { root: className, titleClassName } = classes || {};
  const { subcategory = [] } = category;

  return (
    <div className={htmlClasses([styles.root, className])}>
      {subcategory.map((subCategory) => (
        <div className={styles.section} key={subCategory.id}>
          <div className={styles.head}>
            <h3 className={htmlClasses([styles.title, titleClassName])}>
              {subCategory.name}
            </h3>
            <ViewAllButton link={createCategoryUrl({ id: subCategory.id })} />
          </div>

          <GridView>
            {subCategory.subcategory.map((item) => {
              const tileClassName =
                item.tileSize && company.tileSizeEnabled
                  ? tileClassNames[item.tileSize]
                  : tileClassNames[1];

              return (
                <Card
                  key={item.id}
                  category={item}
                  classes={{ tileClassName }}
                />
              );
            })}
          </GridView>
        </div>
      ))}
    </div>
  );
};

export default observer(CategoriesGrid2M);
